export default "__VITE_ASSET__DDP0x7sY__"